/**
 * Le CHIFFRAGE dans le bon (ébauche validée le 2026-10-24) : ce que le bon comprend au contrat et ce qu'il faut facturer. Lu sur
 * le serveur (jamais calculé ici), d'après ce qui est ENREGISTRÉ : figé une fois le bon validé. Monté seulement pour qui voit les
 * prix ; la route le refuse aux autres de toute façon.
 */
import { useEffect, useState } from 'react';

import { api, type ChiffrageInterventionVue } from '../api/client';
import { chiffrageDuBon } from '../domaine/bon-chiffrage';
import { phraseOrigineChiffrage } from '../domaine/tarifs-mo';

export function ChiffrageBon({ interventionId, cle, palier }: { interventionId: string; cle: number | string; palier?: string | null }) {
  const [chiffrage, setChiffrage] = useState<ChiffrageInterventionVue | null>(null);
  const [erreur, setErreur] = useState(false);

  useEffect(() => {
    let annule = false;
    setErreur(false);
    api
      .chiffrageIntervention(interventionId)
      .then((c) => {
        if (!annule) setChiffrage(c);
      })
      .catch(() => {
        if (!annule) setErreur(true);
      });
    return () => {
      annule = true;
    };
  }, [interventionId, cle]);

  const vue = chiffrage ? chiffrageDuBon(chiffrage, palier) : null;
  return (
    <section className="carte carte-chiffrage-bon">
      <header className="entete-carte">
        <h3>
          Chiffrage <span className="aide">(visible seulement avec le droit des prix)</span>
        </h3>
      </header>
      <div className="carte-corps">
        {erreur && <p className="aide">Le chiffrage n’a pas pu être lu.</p>}
        {!erreur && vue === null && <p className="aide">Chiffrage en cours…</p>}
        {vue && (
          <>
            <table className="tableau tableau-chiffrage-bon">
              <thead>
                <tr>
                  <th>Ligne</th>
                  <th aria-label="Compris ou à facturer" />
                  <th className="montant">Montant HT</th>
                </tr>
              </thead>
              <tbody>
                {vue.rangees.map((r) => (
                  <tr key={r.cle} className={r.pastille === 'compris' ? 'ligne-comprise' : ''}>
                    <td>{r.libelle}</td>
                    <td>
                      {r.pastille === 'compris' && <span className="pastille-chiffrage compris">compris au contrat</span>}
                      {r.pastille === 'a-facturer' && <span className="pastille-en-plus">à facturer</span>}
                    </td>
                    <td className={`montant ${r.manque ? 'texte-attention' : ''}`}>{r.montant}</td>
                  </tr>
                ))}
                <tr className="ligne-total">
                  <td>Total à facturer</td>
                  <td />
                  <td className="montant">{vue.totalAFacturer}</td>
                </tr>
              </tbody>
            </table>
            {vue.phraseCompris && <p className="aide">{vue.phraseCompris}</p>}
            {chiffrage && <p className="aide">{phraseOrigineChiffrage(chiffrage)}</p>}
          </>
        )}
      </div>
    </section>
  );
}
